import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

export default function Tableau() {
  const [board, setBoard] = useState(null);
  const [timer, setTimer] = useState(null);
  const [now, setNow] = useState(new Date());

  const load = useCallback(async () => {
    const [br, tr] = await Promise.all([api.get("/scoreboard"), api.get("/timer")]);
    setBoard(br.data);
    setTimer(tr.data);
  }, []);

  useEffect(() => {
    load();
    const poll = setInterval(load, 3000);
    const clock = setInterval(() => setNow(new Date()), 1000);
    return () => { clearInterval(poll); clearInterval(clock); };
  }, [load]);

  let remaining = null;
  if (timer) {
    if (timer.running && timer.started_at) {
      remaining = Math.max(0, Math.round(timer.duration - (now.getTime() - new Date(timer.started_at).getTime()) / 1000));
    } else if (timer.paused_remaining !== null && timer.paused_remaining !== undefined) {
      remaining = timer.paused_remaining;
    }
  }
  const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

  if (!board) return <div className="min-h-screen bg-black" />;

  return (
    <div className="min-h-screen bg-black text-white flex flex-col" data-testid="tableau-page">
      {/* Top bar */}
      <div className="flex items-center justify-between px-8 py-3 border-b-4 border-[#FF6B1A] bg-[#0F0700]">
        <p className="font-display text-2xl sm:text-3xl">URBAN <span className="text-[#FF6B1A]">FEST</span> 2026</p>
        {board.label && (
          <p className="font-black uppercase tracking-[0.4em] text-[#FFB800] text-sm sm:text-lg" data-testid="tableau-label">{board.label}</p>
        )}
        <span className="font-mono text-xl sm:text-2xl text-[#FFB800]">{now.toLocaleTimeString("fr-FR")}</span>
      </div>

      {/* Chrono */}
      <div
        className={`flex items-center justify-center py-3 border-b-2 ${remaining !== null && remaining === 0 ? "border-[#FF3B30] bg-[#2A0000]" : "border-[#FFB800]/40 bg-[#120900]"}`}
        data-testid="tableau-timer"
      >
        <p
          className={`font-mono font-bold leading-none text-6xl sm:text-8xl ${
            remaining === null ? "text-white/20" : remaining === 0 ? "text-[#FF3B30] animate-ping-slow" : remaining <= 60 ? "text-[#FF3B30]" : "text-[#FFB800]"
          }`}
          data-testid="tableau-timer-value"
        >
          {remaining !== null ? fmt(remaining) : "--:--"}
        </p>
        {timer && !timer.running && remaining !== null && remaining > 0 && (
          <span className="ml-6 text-sm font-black uppercase tracking-[0.4em] text-[#FF9F0A] animate-ping-slow">Pause</span>
        )}
      </div>

      {/* Score */}
      <div className="flex-1 grid grid-cols-[1fr_auto_1fr] items-center gap-4 px-6 sm:px-12 py-8">
        <div className="text-center min-w-0">
          <p className="font-display leading-none break-words text-5xl sm:text-7xl xl:text-8xl" data-testid="tableau-team-a">{board.team_a}</p>
          <p className="font-display leading-none text-[#FF6B1A] mt-6 text-8xl sm:text-9xl xl:text-[12rem]" data-testid="tableau-score-a">{board.score_a}</p>
        </div>
        <p className="font-display text-6xl sm:text-8xl text-white/20">–</p>
        <div className="text-center min-w-0">
          <p className="font-display leading-none break-words text-5xl sm:text-7xl xl:text-8xl" data-testid="tableau-team-b">{board.team_b}</p>
          <p className="font-display leading-none text-[#FF6B1A] mt-6 text-8xl sm:text-9xl xl:text-[12rem]" data-testid="tableau-score-b">{board.score_b}</p>
        </div>
      </div>

      {/* À suivre */}
      {(board.up_next || []).length > 0 && (
        <div className="border-t-4 border-[#FFB800] bg-[#0F0700] px-8 py-4" data-testid="tableau-upnext">
          <p className="text-xs font-black uppercase tracking-[0.4em] text-[#FFB800] mb-2">À suivre</p>
          <div className="flex gap-8 flex-wrap">
            {board.up_next.map((line, i) => (
              <p key={i} className="font-display text-2xl sm:text-3xl text-white/85">
                <span className="text-[#FF6B1A] mr-2">{i + 1}.</span>{line}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
